import type { GlobalSharedProductListItemDto } from '@ori/global-api-client-react';
import { isNonNullable } from '@ori/ts-utils';

export const mapCurrent = (items: GlobalSharedProductListItemDto[]) =>
  items.map(({ itemCode }) => itemCode).filter(isNonNullable);
